<template>
  <div class="contact fixed-nav">
    <MainHeader :tiles="false" :fixedMenu="true">
      <router-link :to="{ name: 'virtual'}">
        <svg>
          <use v-if="selectedTranslation === 'en'" xlink:href="#logoWmkSvgEng"></use>
          <use v-else xlink:href="#logoWmkSvg"></use>
        </svg>
      </router-link>
    </MainHeader>
    <div class="sections">
      <ContactSection
        :images="contactData.items"
        :text="contactData.headers"
        :newsletter="contactData.emailNotification"
        :errors="errorData" />
      <ContactForm :formData="contactData.form" :errors="errorData" />
      <MainFooter :content="footerData"/>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import MainHeader from '@/components/MainHeader.vue'
import MainFooter from '@/components/MainFooter.vue'
import ContactSection from '@/components/ContactSection.vue'
import ContactForm from '@/components/ContactForm.vue'

export default {
  name: 'contact',
  components: {
    MainHeader,
    MainFooter,
    ContactSection,
    ContactForm
  },
  methods: {
    ...mapActions([
      'resetActiveFilters'
    ])
  },
  computed: {
    ...mapGetters([
      'contactData',
      'errorData',
      'footerData',
      'selectedTranslation'
    ])
  },
  mounted () {
    this.resetActiveFilters()
  }
}
</script>

<style scoped lang="scss">
.dark {
  background-color: $bg-dark;
  color: $text-light;
}
</style>
